export function downloadFile(url: string, fileName?: string) {
  const xhr = new XMLHttpRequest();
  xhr.open("GET", url, true);
  xhr.responseType = "blob";

  xhr.onload = function () {
    const blob = xhr.response;
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName || url.split("/").pop() || "untitled"; // 默认使用URL中的文件名

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
  };

  xhr.send();
}

export function downloadBlob(blob: Blob, fileName: string) {
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName; // 默认使用URL中的文件名

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
}

// export async function downloadFile(url: string, fileName?: string) {
//   try {
//     const response = await fetch(url, {
//       mode: "cors", // 确保跨域请求可以正常处理
//     });

//     if (!response.ok) {
//       throw new Error(`HTTP error! status: ${response.status}`);
//     }

//     const blob = await response.blob();
//     const urlObject = URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.href = urlObject;
//     link.download = fileName || url.split("/").pop() || "untitled"; // 默认使用URL中的文件名
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     URL.revokeObjectURL(urlObject);
//   } catch (error) {
//     console.error("Error downloading file:", error);
//   }
// }
